document.addEventListener("DOMContentLoaded", function(event) {
  let urlParams = new URLSearchParams(window.location.search);
  let sizeParam = urlParams.get('Size');
  if (sizeParam) {
    document.querySelectorAll('[data-block-type="product-colors"] a').forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-' + sizeParam);
      link.href = current + '?variant=' + varId + '&Size=' + sizeParam;
    }); 
    document.querySelectorAll('[data-block-type="product-rises"] a').forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-' + sizeParam);
      link.href = current + '?variant=' + varId + '&Size=' + sizeParam;
    });
    document.querySelectorAll('[data-block-type="product-lengths"] a').forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-' + sizeParam);
      link.href = current + '?variant=' + varId + '&Size=' + sizeParam;
    });
  } 

  let productCardColors = document.querySelectorAll('product-card .product-card__swatch-list label.color-swatch');
  productCardColors.forEach(productCardColor => {
    productCardColor.addEventListener('click', (event) => {
      let closestProductCard = event.target.closest('product-card');
      let quickBuyId = event.target.getAttribute('quick-buy-id');
      let thisProductCardColors = closestProductCard.querySelectorAll('.product-card__swatch-list label.color-swatch');
      thisProductCardColors.forEach(thisProductCardColor => {
        if (thisProductCardColor != event.target) {
          thisProductCardColor.previousElementSibling.checked = false;
          thisProductCardColor.classList.remove('is-selected');
        }
      });
      if (closestProductCard) {
        if (productCardColor.hasAttribute('data-variant-product-image')) {
          let main_image = closestProductCard.querySelector('.product-card__image--primary');
          let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

          var newImageElement = document.createElement('img');
          newImageElement.className = 'product-card__image product-card__image--primary';
          newImageElement.setAttribute('width', '1200px');
          newImageElement.setAttribute('src', productCardColor.getAttribute('data-variant-product-image'));

          var newAltImageElement = document.createElement('img');
          newAltImageElement.className = 'product-card__image product-card__image--secondary';
          newAltImageElement.setAttribute('src', productCardColor.getAttribute('data-variant-product-alt-image'));
          
          closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
          closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
        }

        var variantHandle = productCardColor.getAttribute('data-variant-handle');
        var variantUrl = productCardColor.getAttribute('data-variant-url');
        var variantTitle = productCardColor.getAttribute('data-variant-title');
        var variantPrice = productCardColor.getAttribute('data-variant-price');
        var variantComparePrice = productCardColor.getAttribute('data-variant-compare-price');
        var variantFullPrice = productCardColor.getAttribute('data-variant-full-price');
        var variantSavings = productCardColor.getAttribute('data-variant-savings');
        var variantAvailable = productCardColor.getAttribute('data-variant-available');

        if (variantFullPrice == "true") {
          closestProductCard.classList.remove("Sale");
          closestProductCard.classList.add("Full");
        } else {
          closestProductCard.classList.remove("Full");
          closestProductCard.classList.add("Sale");
        }
        if (variantAvailable == "true") {
          closestProductCard.classList.remove("Sold-Out");
          closestProductCard.classList.add("Available");
        } else {
          closestProductCard.classList.remove("Available");
          closestProductCard.classList.add("Sold-Out");
        }
        closestProductCard.setAttribute('handle', variantHandle);
        closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
        closestProductCard.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
        closestProductCard.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
        closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
        closestProductCard.querySelector('.product-card__info .text-on-sale').innerHTML = variantSavings;
        let quickBuyButtons = closestProductCard.querySelectorAll('.product-card__quick-buy button');
        quickBuyButtons.forEach(quickBuyButton => {
          quickBuyButton.setAttribute('aria-controls', quickBuyId)
        });
      }
    });
  });

  const mainCollection = document.querySelector('.shopify-section--main-collection');
  if (mainCollection) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          let productCardColors = document.querySelectorAll('product-card .product-card__swatch-list label.color-swatch');
          productCardColors.forEach(productCardColor => {
            productCardColor.addEventListener('click', (event) => {
              let closestProductCard = event.target.closest('product-card');
              let quickBuyId = event.target.getAttribute('quick-buy-id');
              let thisProductCardColors = closestProductCard.querySelectorAll('.product-card__swatch-list label.color-swatch');
              thisProductCardColors.forEach(thisProductCardColor => {
                if (thisProductCardColor != event.target) {
                  thisProductCardColor.previousElementSibling.checked = false;
                  thisProductCardColor.classList.remove('is-selected');
                }
              });
              if (closestProductCard) {
                if (productCardColor.hasAttribute('data-variant-product-image')) {
                  let main_image = closestProductCard.querySelector('.product-card__image--primary');
                  let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

                  var newImageElement = document.createElement('img');
                  newImageElement.className = 'product-card__image product-card__image--primary';
                  newImageElement.setAttribute('width', '1200px');
                  newImageElement.setAttribute('src', productCardColor.getAttribute('data-variant-product-image'));

                  var newAltImageElement = document.createElement('img');
                  newAltImageElement.className = 'product-card__image product-card__image--secondary';
                  newAltImageElement.setAttribute('src', productCardColor.getAttribute('data-variant-product-alt-image'));
                  
                  closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
                  closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
                }

                var variantHandle = productCardColor.getAttribute('data-variant-handle');
                var variantUrl = productCardColor.getAttribute('data-variant-url');
                var variantTitle = productCardColor.getAttribute('data-variant-title');
                var variantPrice = productCardColor.getAttribute('data-variant-price');
                var variantComparePrice = productCardColor.getAttribute('data-variant-compare-price');
                var variantFullPrice = productCardColor.getAttribute('data-variant-full-price');
                var variantSavings = productCardColor.getAttribute('data-variant-savings');
                var variantAvailable = productCardColor.getAttribute('data-variant-available');

                if (variantFullPrice == "true") {
                  closestProductCard.classList.remove("Sale");
                  closestProductCard.classList.add("Full");
                } else {
                  closestProductCard.classList.remove("Full");
                  closestProductCard.classList.add("Sale");
                }
                if (variantAvailable == "true") {
                  closestProductCard.classList.remove("Sold-Out");
                  closestProductCard.classList.add("Available");
                } else {
                  closestProductCard.classList.remove("Available");
                  closestProductCard.classList.add("Sold-Out");
                }
                closestProductCard.setAttribute('handle', variantHandle);
                closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
                closestProductCard.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
                closestProductCard.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
                closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
                closestProductCard.querySelector('.product-card__info .text-on-sale').innerHTML = variantSavings;
                let quickBuyButtons = closestProductCard.querySelectorAll('.product-card__quick-buy button');
                quickBuyButtons.forEach(quickBuyButton => {
                  quickBuyButton.setAttribute('aria-controls', quickBuyId)
                });
              }
            });
          });
        }
      }
    });

    const config = { childList: true };
    observer.observe(mainCollection, config);
  }

  const relatedProducts = document.querySelector('.shopify-section--related-products product-recommendations');
  if (relatedProducts) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          let productCardColors = document.querySelectorAll('product-card .product-card__swatch-list label.color-swatch');
          productCardColors.forEach(productCardColor => {
            productCardColor.addEventListener('click', (event) => {
              let closestProductCard = event.target.closest('product-card');
              let quickBuyId = event.target.getAttribute('quick-buy-id');
              let thisProductCardColors = closestProductCard.querySelectorAll('.product-card__swatch-list label.color-swatch');
              thisProductCardColors.forEach(thisProductCardColor => {
                if (thisProductCardColor != event.target) {
                  thisProductCardColor.previousElementSibling.checked = false;
                  thisProductCardColor.classList.remove('is-selected');
                }
              });
              if (closestProductCard) {
                if (productCardColor.hasAttribute('data-variant-product-image')) {
                  let main_image = closestProductCard.querySelector('.product-card__image--primary');
                  let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

                  var newImageElement = document.createElement('img');
                  newImageElement.className = 'product-card__image product-card__image--primary';
                  newImageElement.setAttribute('width', '1200px');
                  newImageElement.setAttribute('src', productCardColor.getAttribute('data-variant-product-image'));

                  var newAltImageElement = document.createElement('img');
                  newAltImageElement.className = 'product-card__image product-card__image--secondary';
                  newAltImageElement.setAttribute('src', productCardColor.getAttribute('data-variant-product-alt-image'));
                  
                  closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
                  closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
                }

                var variantHandle = productCardColor.getAttribute('data-variant-handle');
                var variantUrl = productCardColor.getAttribute('data-variant-url');
                var variantTitle = productCardColor.getAttribute('data-variant-title');
                var variantPrice = productCardColor.getAttribute('data-variant-price');
                var variantComparePrice = productCardColor.getAttribute('data-variant-compare-price');
                var variantFullPrice = productCardColor.getAttribute('data-variant-full-price');
                var variantSavings = productCardColor.getAttribute('data-variant-savings');
                var variantAvailable = productCardColor.getAttribute('data-variant-available');

                if (variantFullPrice == "true") {
                  closestProductCard.classList.remove("Sale");
                  closestProductCard.classList.add("Full");
                } else {
                  closestProductCard.classList.remove("Full");
                  closestProductCard.classList.add("Sale");
                }
                if (variantAvailable == "true") {
                  closestProductCard.classList.remove("Sold-Out");
                  closestProductCard.classList.add("Available");
                } else {
                  closestProductCard.classList.remove("Available");
                  closestProductCard.classList.add("Sold-Out");
                }
                closestProductCard.setAttribute('handle', variantHandle);
                closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
                closestProductCard.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
                closestProductCard.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
                closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
                closestProductCard.querySelector('.product-card__info .text-on-sale').innerHTML = variantSavings;
                let quickBuyButtons = closestProductCard.querySelectorAll('.product-card__quick-buy button');
                quickBuyButtons.forEach(quickBuyButton => {
                  quickBuyButton.setAttribute('aria-controls', quickBuyId)
                });
              }
            });
          });
        }
      }
    });

    const config = { childList: true };
    observer.observe(relatedProducts, config);
  }

  const mainSearch = document.querySelector('.shopify-section--main-search #collection');
  if (mainSearch) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          setTimeout(() => {
            let productCardColors = document.querySelectorAll('product-card .product-card__swatch-list label.color-swatch');
            productCardColors.forEach(productCardColor => {
              productCardColor.addEventListener('click', (event) => {
                let closestProductCard = event.target.closest('product-card');
                let quickBuyId = event.target.getAttribute('quick-buy-id');
                let thisProductCardColors = closestProductCard.querySelectorAll('.product-card__swatch-list label.color-swatch');
                thisProductCardColors.forEach(thisProductCardColor => {
                  if (thisProductCardColor != event.target) {
                    thisProductCardColor.previousElementSibling.checked = false;
                    thisProductCardColor.classList.remove('is-selected');
                  }
                });
                if (closestProductCard) {
                if (productCardColor.hasAttribute('data-variant-product-image')) {
                  let main_image = closestProductCard.querySelector('.product-card__image--primary');
                  let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

                  var newImageElement = document.createElement('img');
                  newImageElement.className = 'product-card__image product-card__image--primary';
                  newImageElement.setAttribute('width', '1200px');
                  newImageElement.setAttribute('src', productCardColor.getAttribute('data-variant-product-image'));

                  var newAltImageElement = document.createElement('img');
                  newAltImageElement.className = 'product-card__image product-card__image--secondary';
                  newAltImageElement.setAttribute('src', productCardColor.getAttribute('data-variant-product-alt-image'));
                  
                  closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
                  closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
                }

                var variantHandle = productCardColor.getAttribute('data-variant-handle');
                var variantUrl = productCardColor.getAttribute('data-variant-url');
                var variantTitle = productCardColor.getAttribute('data-variant-title');
                var variantPrice = productCardColor.getAttribute('data-variant-price');
                var variantComparePrice = productCardColor.getAttribute('data-variant-compare-price');
                var variantFullPrice = productCardColor.getAttribute('data-variant-full-price');
                var variantSavings = productCardColor.getAttribute('data-variant-savings');
                var variantAvailable = productCardColor.getAttribute('data-variant-available');

                if (variantFullPrice == "true") {
                  closestProductCard.classList.remove("Sale");
                  closestProductCard.classList.add("Full");
                } else {
                  closestProductCard.classList.remove("Full");
                  closestProductCard.classList.add("Sale");
                }
                if (variantAvailable == "true") {
                  closestProductCard.classList.remove("Sold-Out");
                  closestProductCard.classList.add("Available");
                } else {
                  closestProductCard.classList.remove("Available");
                  closestProductCard.classList.add("Sold-Out");
                }
                closestProductCard.setAttribute('handle', variantHandle);
                closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
                closestProductCard.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
                closestProductCard.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
                closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
                closestProductCard.querySelector('.product-card__info .text-on-sale').innerHTML = variantSavings;
                let quickBuyButtons = closestProductCard.querySelectorAll('.product-card__quick-buy button');
                quickBuyButtons.forEach(quickBuyButton => {
                  quickBuyButton.setAttribute('aria-controls', quickBuyId)
                });
              }
              });
            });
          }, 2000);
        }
      }
    });

    const config = { childList: true };
    observer.observe(mainSearch, config);
  }

  const predictiveSearch = document.querySelector('#predictive-search');
  if (predictiveSearch) {
    const predictiveSearchShadowRoot = predictiveSearch.shadowRoot;
    if (predictiveSearchShadowRoot) {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            let productCardColors = document.querySelectorAll('product-card .product-card__swatch-list label.color-swatch');
            productCardColors.forEach(productCardColor => {
              productCardColor.addEventListener('click', (event) => {
                let closestProductCard = event.target.closest('product-card');
                let quickBuyId = event.target.getAttribute('quick-buy-id');
                let thisProductCardColors = closestProductCard.querySelectorAll('.product-card__swatch-list label.color-swatch');
                thisProductCardColors.forEach(thisProductCardColor => {
                  if (thisProductCardColor != event.target) {
                    thisProductCardColor.previousElementSibling.checked = false;
                    thisProductCardColor.classList.remove('is-selected');
                  }
                });
                if (closestProductCard) {
                  if (productCardColor.hasAttribute('data-variant-product-image')) {
                    let main_image = closestProductCard.querySelector('.product-card__image--primary');
                    let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

                    var newImageElement = document.createElement('img');
                    newImageElement.className = 'product-card__image product-card__image--primary';
                    newImageElement.setAttribute('width', '1200px');
                    newImageElement.setAttribute('src', productCardColor.getAttribute('data-variant-product-image'));

                    var newAltImageElement = document.createElement('img');
                    newAltImageElement.className = 'product-card__image product-card__image--secondary';
                    newAltImageElement.setAttribute('src', productCardColor.getAttribute('data-variant-product-alt-image'));
                    
                    closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
                    closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
                  }

                  var variantHandle = productCardColor.getAttribute('data-variant-handle');
                  var variantUrl = productCardColor.getAttribute('data-variant-url');
                  var variantTitle = productCardColor.getAttribute('data-variant-title');
                  var variantPrice = productCardColor.getAttribute('data-variant-price');
                  var variantComparePrice = productCardColor.getAttribute('data-variant-compare-price');
                  var variantFullPrice = productCardColor.getAttribute('data-variant-full-price');
                  var variantSavings = productCardColor.getAttribute('data-variant-savings');
                  var variantAvailable = productCardColor.getAttribute('data-variant-available');

                  if (variantFullPrice == "true") {
                    closestProductCard.classList.remove("Sale");
                    closestProductCard.classList.add("Full");
                  } else {
                    closestProductCard.classList.remove("Full");
                    closestProductCard.classList.add("Sale");
                  }
                  if (variantAvailable == "true") {
                    closestProductCard.classList.remove("Sold-Out");
                    closestProductCard.classList.add("Available");
                  } else {
                    closestProductCard.classList.remove("Available");
                    closestProductCard.classList.add("Sold-Out");
                  }
                  closestProductCard.setAttribute('handle', variantHandle);
                  closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
                  closestProductCard.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
                  closestProductCard.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
                  closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
                  closestProductCard.querySelector('.product-card__info .text-on-sale').innerHTML = variantSavings;
                  let quickBuyButtons = closestProductCard.querySelectorAll('.product-card__quick-buy button');
                  quickBuyButtons.forEach(quickBuyButton => {
                    quickBuyButton.setAttribute('aria-controls', quickBuyId)
                  });
                }
              });
            });
          }
        }
      });

      const config = { childList: true };
      observer.observe(predictiveSearchShadowRoot, config);
    }
  }
  
  let sizeGuideTabs = document.querySelectorAll('.size-guide-popup-tabs ul li');
  let sizeGuideContents = document.querySelectorAll('.size-guide-popup-content > div');
  sizeGuideTabs.forEach(sizeGuideTab => {
    sizeGuideTab.addEventListener('click', (event) => {
      sizeGuideTabs.forEach(sizeGuideTab => {
        sizeGuideTab.classList.toggle('tab-active');
      });
      sizeGuideContents.forEach(sizeGuideContent => {
        sizeGuideContent.classList.toggle('content-active');
      });
    });
  });

  let sizeGuideMeasurements = document.querySelectorAll('.size-guide-popup-measurements ul li');
  let sizeGuideMeasurementConversions = document.querySelectorAll('.measurement-conversion');
  sizeGuideMeasurements.forEach(sizeGuideMeasurement => {
    sizeGuideMeasurement.addEventListener('click', (event) => {
      sizeGuideMeasurements.forEach(sizeGuideMeasurement => {
        sizeGuideMeasurement.classList.toggle('measurement-active');
      });
      sizeGuideMeasurementConversions.forEach(sizeGuideMeasurementConversion => {
         if (sizeGuideMeasurementConversion.classList.contains('m-cm')) {
            sizeGuideMeasurementConversion.classList.remove('m-cm');
            sizeGuideMeasurementConversion.classList.add('m-in');
          } else {
            sizeGuideMeasurementConversion.classList.remove('m-in');
            sizeGuideMeasurementConversion.classList.add('m-cm');
          }
      });
    });
  });

  let mySizeOptions = document.querySelectorAll('.see-size__content .block-swatch');
  let mySizeMeasurements = document.querySelectorAll('.see-size__content .measurements');
  let mySizeImages = document.querySelectorAll('.see-size__content .see-size__img_block');
  mySizeOptions.forEach(mySizeOption => {
    mySizeOption.addEventListener('click', (event) => {
      if (!mySizeOption.classList.contains('is-selected')) {
        mySizeOptions.forEach(mySizeOption => {
          mySizeOption.classList.remove('is-selected');
        });
        mySizeOption.classList.add('is-selected');
        let selectedSize = mySizeOption.getAttribute("data-value");
        let selectedSizeValue = selectedSize.trim().toLowerCase();

        mySizeMeasurements.forEach(mySizeMeasurement => {
          let mySizeMeasurementValue = mySizeMeasurement.getAttribute("data-value");
          mySizeMeasurementValue = mySizeMeasurementValue.trim().toLowerCase();
          if (mySizeMeasurementValue == selectedSizeValue) {
            mySizeMeasurement.classList.remove('hidden');
          } else {
            mySizeMeasurement.classList.add('hidden');
          }
        });

        mySizeImages.forEach(mySizeImage => {
          let mySizeImageValue = mySizeImage.getAttribute("data-value");
          mySizeImageValue = mySizeImageValue.trim().toLowerCase();
          if (mySizeImageValue == selectedSizeValue) {
            mySizeImage.classList.remove('hidden');
          } else {
            mySizeImage.classList.add('hidden');
          }
        });
      }
    });
  });

  const sizeGuideRadios = document.querySelectorAll('.shopify-section--size-guide .tabs-desktop input');

  sizeGuideRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      var sizeGuideActivePanel = radio.closest('.tab');
      var sizeGuideActivePanelHeight = sizeGuideActivePanel.querySelector('.panel').offsetHeight;
      document.querySelector('.shopify-section--size-guide .tabs-desktop').style.minHeight = sizeGuideActivePanelHeight + 'px';
    });
  });

  const sizeGuideMobileRadios = document.querySelectorAll('.shopify-section--size-guide .tabs-mobile input');

  sizeGuideMobileRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      const sizeGuideMobilePanels = document.querySelectorAll('.shopify-section--size-guide .content-mobile .panel');
      sizeGuideMobilePanels.forEach(panel => {
        panel.style.display = 'none';
      });
      let activePanel = radio.id;
      document.querySelector('.shopify-section--size-guide .content-mobile .panel[data-tab=' + activePanel + ']').style.display = 'block';
    });
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible'); // Add 'visible' class
      } else {
        entry.target.classList.remove('visible'); // Remove 'visible' class
      }
    });
  });

  const sizeChartArrows = document.querySelectorAll('.size-guide-popup-table .prev-next-button'); // Select elements to observe
  sizeChartArrows.forEach(element => {
    observer.observe(element);
  });

  function debounce(func, wait = 100) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function handleScrollPosition(element) {
    const startClass = 'is-scrollable-x-start';
    const endClass = 'is-scrollable-x-end';

    // scrollLeft is 0 when at the absolute start
    if (element.scrollLeft === 0) {
      element.classList.add(startClass);
    } else {
      element.classList.remove(startClass);
    }

    // Check if the user is near or at the end of the scroll area
    // scrollLeft + clientWidth === scrollWidth
    // We use Math.ceil/floor for robustness due to potential sub-pixel rendering issues in some browsers
    const isAtEnd = Math.ceil(element.scrollLeft + element.clientWidth) >= element.scrollWidth;
    
    if (isAtEnd) {
      element.classList.add(endClass);
    } else {
      element.classList.remove(endClass);
    }
  }

  function initializeScrollTracking(selector) {
    const elements = document.querySelectorAll(selector);
    const scrollableClass = 'is-scrollable-x';

    elements.forEach(element => {
      const isHorizontallyScrollable = element.scrollWidth > element.clientWidth;

      if (isHorizontallyScrollable) {
        // 1. Add the main class indicating it *can* scroll
        element.classList.add(scrollableClass);

        // 2. Run the position check immediately on load
        handleScrollPosition(element);
        
        // 3. Attach a scroll listener to update the start/end classes dynamically
        element.addEventListener('scroll', () => handleScrollPosition(element));

      } else {
        // If not scrollable, ensure all classes are removed
        element.classList.remove(scrollableClass, 'is-scrollable-x-start', 'is-scrollable-x-end');
      }
    });
  }
  initializeScrollTracking('.product-card__swatch-list .scroll-area');

  const debouncedResizeHandler = debounce(() => {
    initializeScrollTracking('.product-card__swatch-list .scroll-area');
  }, 200);

  window.addEventListener('resize', debouncedResizeHandler);
});

document.addEventListener('variant:change', function(event) {
  let selectedSize = event.detail.variant.option2.replace(/\s/g, "").toLowerCase();
  document.querySelectorAll('[data-block-type="product-colors"] a').forEach(link => {
    var current = link.href.split('?')[0];
    var varId = link.getAttribute('data-size-' + selectedSize);
    link.href = current + '?variant=' + varId + '&Size=' + selectedSize;
  });  

  document.querySelectorAll('[data-block-type="product-rises"] a').forEach(link => {
    var current = link.href.split('?')[0];
    var varId = link.getAttribute('data-size-' + selectedSize);
    link.href = current + '?variant=' + varId + '&Size=' + selectedSize;
  });
  
  document.querySelectorAll('[data-block-type="product-lengths"] a').forEach(link => {
    var current = link.href.split('?')[0];
    var varId = link.getAttribute('data-size-' + selectedSize);
    link.href = current + '?variant=' + varId + '&Size=' + selectedSize;
  });

  let sizeGuideTabs = document.querySelectorAll('.size-guide-popup-tabs ul li');
  let sizeGuideContents = document.querySelectorAll('.size-guide-popup-content > div');
  sizeGuideTabs.forEach(sizeGuideTab => {
    sizeGuideTab.addEventListener('click', (event) => {
      sizeGuideTabs.forEach(sizeGuideTab => {
        sizeGuideTab.classList.toggle('tab-active');
      });
      sizeGuideContents.forEach(sizeGuideContent => {
        sizeGuideContent.classList.toggle('content-active');
      });
    });
  });

  let sizeGuideMeasurements = document.querySelectorAll('.size-guide-popup-measurements ul li');
  let sizeGuideMeasurementConversions = document.querySelectorAll('.measurement-conversion');
  sizeGuideMeasurements.forEach(sizeGuideMeasurement => {
    sizeGuideMeasurement.addEventListener('click', (event) => {
      sizeGuideMeasurements.forEach(sizeGuideMeasurement => {
        sizeGuideMeasurement.classList.toggle('measurement-active');
      });
      sizeGuideMeasurementConversions.forEach(sizeGuideMeasurementConversion => {
         if (sizeGuideMeasurementConversion.classList.contains('m-cm')) {
            sizeGuideMeasurementConversion.classList.remove('m-cm');
            sizeGuideMeasurementConversion.classList.add('m-in');
          } else {
            sizeGuideMeasurementConversion.classList.remove('m-in');
            sizeGuideMeasurementConversion.classList.add('m-cm');
          }
      });
    });
  });

  let mySizeOptions = document.querySelectorAll('.see-size__content .block-swatch');
  let mySizeMeasurements = document.querySelectorAll('.see-size__content .measurements');
  let mySizeImages = document.querySelectorAll('.see-size__content .see-size__img_block');
  mySizeOptions.forEach(mySizeOption => {
    mySizeOption.addEventListener('click', (event) => {
      if (!mySizeOption.classList.contains('is-selected')) {
        mySizeOptions.forEach(mySizeOption => {
          mySizeOption.classList.remove('is-selected');
        });
        mySizeOption.classList.add('is-selected');
        let selectedSize = mySizeOption.getAttribute("data-value");
        let selectedSizeValue = selectedSize.trim().toLowerCase();

        mySizeMeasurements.forEach(mySizeMeasurement => {
          let mySizeMeasurementValue = mySizeMeasurement.getAttribute("data-value");
          mySizeMeasurementValue = mySizeMeasurementValue.trim().toLowerCase();
          if (mySizeMeasurementValue == selectedSizeValue) {
            mySizeMeasurement.classList.remove('hidden');
          } else {
            mySizeMeasurement.classList.add('hidden');
          }
        });

        mySizeImages.forEach(mySizeImage => {
          let mySizeImageValue = mySizeImage.getAttribute("data-value");
          mySizeImageValue = mySizeImageValue.trim().toLowerCase();
          if (mySizeImageValue == selectedSizeValue) {
            mySizeImage.classList.remove('hidden');
          } else {
            mySizeImage.classList.add('hidden');
          }
        });
      }
    });
  });

  const sizeGuideRadios = document.querySelectorAll('.shopify-section--size-guide .tabs-desktop input');

  sizeGuideRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      var sizeGuideActivePanel = radio.closest('.tab');
      var sizeGuideActivePanelHeight = sizeGuideActivePanel.querySelector('.panel').offsetHeight;
      document.querySelector('.shopify-section--size-guide .tabs-desktop').style.minHeight = sizeGuideActivePanelHeight + 'px';
    });
  });

  const sizeGuideMobileRadios = document.querySelectorAll('.shopify-section--size-guide .tabs-mobile input');

  sizeGuideMobileRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      const sizeGuideMobilePanels = document.querySelectorAll('.shopify-section--size-guide .content-mobile .panel');
      sizeGuideMobilePanels.forEach(panel => {
        panel.style.display = 'none';
      });
      let activePanel = radio.id;
      document.querySelector('.shopify-section--size-guide .content-mobile .panel[data-tab=' + activePanel + ']').style.display = 'block';
    });
  });
});

